import { Container } from "@mantine/core"

const MantineContainer = (props: any) => {
    const { children, mt, fluid, size, className } = props
    return (
        <Container
            size={size}
            fluid={fluid ? true : false}
            mt={mt}
            className={className}
        >
            {children}
        </Container>
    )
}
export default MantineContainer;